import { DatePicker } from "antd";
import locale from "antd/es/locale/es_ES";
const { RangePicker } = DatePicker;

const RangeDate = ({ placeholder, value, onChange }) => {
    return <RangePicker
        style={{
            fontSize: '12px',
            backgroundColor: "transparent",
            borderColor: "transparent",
            color: "#686868",
        }}
        suffixIcon=''
        allowClear={false}
        variant="borderless"
        placeholder={placeholder} locale={locale} format={"DD/MM/YY"} value={value} onChange={onChange} />;
    // return <RangePicker />
};

export default RangeDate;
